"use client"

import { useState } from "react"

import { cn } from "@/lib/utils"

export function PricingToggleIsland({ onLabel = "Monthly", offLabel = "Annual" }: { onLabel?: string; offLabel?: string }) {
  const [annual, setAnnual] = useState(true)

  return (
    <div className="inline-flex rounded-full border border-border/70 bg-card p-1 shadow-sm" role="group" aria-label="Billing period">
      {[false, true].map((isAnnual) => (
        <button
          key={String(isAnnual)}
          type="button"
          onClick={() => setAnnual(isAnnual)}
          className={cn("rounded-full px-4 py-2 text-sm font-semibold transition-colors", annual === isAnnual ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground")}
          aria-pressed={annual === isAnnual}
        >
          {isAnnual ? offLabel : onLabel}
        </button>
      ))}
    </div>
  )
}